<template>
  <b-radio-group
    v-model="type"
    buttons
    button-variant="outline-primary"
    :options="options"
  />
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { FieldTypes, FieldMapItem, FieldCalculationV2Config } from '@/types'

const props = {
  field: {
    type: Object as PropType<FieldMapItem | FieldCalculationV2Config>,
    required: true,
  },
}

@Component
export default class UpdateFieldType extends Vue.extend({ props }) {
  options = [
    { value: FieldTypes.STRING, text: 'abc' },
    { value: FieldTypes.NUMERIC, text: '123' },
    { value: FieldTypes.MONETARY, text: '$£€' },
  ]

  get type () {
    return this.field.type
  }

  set type (newValue) {
    this.field.type = newValue
  }
}

</script>
